import React from "react";

import TickIcon from "../../images/icons/tick-dark.inline.svg";
import TickIconLight from "../../images/icons/tick-icon-light.inline.svg";
import TickIconLightAlt from "../../images/icons/tick-icon-alt.inline.svg";

const ListNestedTextCard = ({
  list = [],
  isGVI = false,
  isNested = false,
  outerContainerStyle = "flex flex-col gap-y-2",
  innerContainerStyle = "flex items-center gap-x-2",
  nestedListOuterContainer = "w-full flex flex-col gap-2",
  nestedListInnerContainer = "flex items-center",
  nestedListItemsContainer = "flex items-center px-5",
  iconClass = "w-4 sm:w-3 h-4 sm:h-3 fill-black-lighter ",
  iconNestedListIconClass = "w-4 sm:w-3 h-4 sm:h-3 fill-black-lighter  stroke-gray-undecimal",
  listItemClass = "pl-3 font-body font-normal",
  nestedListItemClass = "pl-3"
}) => {
  const Icon = isNested ? TickIconLightAlt : isGVI ? TickIcon : TickIconLight;

  if (list?.length < 1) <></>;

  return (
    <ul className={outerContainerStyle}>
      {list?.map((item, index) => (
        <li key={index} className={innerContainerStyle}>
          {item?.items ? (
            <div className={nestedListOuterContainer}>
              <div className={nestedListInnerContainer}>
                <Icon className={iconClass} />
                <span
                  className={listItemClass}
                  dangerouslySetInnerHTML={{ __html: item?.title || item }}
                />
              </div>
              <div className={nestedListItemsContainer}>
                <ListNestedTextCard
                  list={item?.items}
                  iconClass={iconNestedListIconClass}
                  listItemClass={nestedListItemClass}
                  isNested={true}
                />
              </div>
            </div>
          ) : (
            <>
              <Icon className={iconClass} />
              <div
                className={listItemClass}
                dangerouslySetInnerHTML={{ __html: item?.title || item }}
              />
            </>
          )}
        </li>
      ))}
    </ul>
  );
};

export default ListNestedTextCard;
